import React from 'react';

import TouchLink from '../../components/TouchLink';

import ProgressCircle from '../../components/ProgressCircle/ProgressCircle';


const Link = React.createClass({
    handleClicked( subChapterKey, firstExerciseId) {
        this.props.handleClicked(subChapterKey, firstExerciseId);
    },

    render() {
		const to = this.props.to;
		const className = this.props.className;
        const subChapterKey= this.props.subChapterKey;
        const firstExerciseId = this.props.firstExerciseId;

		return(to ? <TouchLink to={to} className={className}>{this.props.children}</TouchLink> : <div className={className} onClick={this.handleClicked.bind(this, subChapterKey, firstExerciseId)}>{this.props.children}</div>);
	}
});

const SubchapterItem = React.createClass({
    handleClicked( subChapterKey, firstExerciseId) {
        this.props.handleClicked(subChapterKey, firstExerciseId);
    },

	render() {
        const to = this.props.to;
		const label = this.props.label;
		const state = this.props.state;
		const progress = this.props.progress;
		const progressLabel = this.props.progressLabel;
        const subChapterKey= this.props.subChapterKey;
        const firstExerciseId = this.props.firstExerciseId;

		return (
			<li className={`subchapter ${state} ${progress == '100' ? 'isComplete' : ''}`}>
				<Link
                    to={to}
                    className={`subchapter-link`}
                    firstExerciseId={firstExerciseId}
                    subChapterKey={subChapterKey}
                    handleClicked={this.handleClicked}
                >
					<div className={`subchapter-graphic`}>
						<ProgressCircle
							progress={progress}
							progressType="step"
						    size={40}
						    label={progressLabel}
						/>
					</div>
					<div className={`subchapter-content`}>
						<span className="subchapter-header">{label}</span>
					</div>
				</Link>
			</li>
		);
	}
});

export default SubchapterItem;


/** WEBPACK FOOTER **
 ** ./src/components/SubchapterItem/SubchapterItem.js
 **/